export default __webpack_public_path__ + "static/media/Bed, Yellow.79973102.png";